import { AuthorizationCredentialsServiceFactory } from 'frontcore/domain/authorization/factory'
import { LogoutEmit } from 'frontcore/domain/authorization/model/types'

export interface AuthorizationSAMLUseCase {
  logout: () => void
  continueLogoutProcess: (requestId: string, applicationId?: string) => void
}

class UseSAMLLogout {

  readonly #emit: LogoutEmit

  constructor (emit: LogoutEmit) {
    this.#emit = emit
  }

  use () {
    const logout = () => {
      const url = typeof ENV_PUBLIC_PATH !== 'undefined' ? `${MPS_URL}${ENV_PUBLIC_PATH}` : MPS_URL
      const urlObj = new URL(url)
  
      const encodedURI = encodeURIComponent(urlObj.toString())
      const redirectUri = `${API_URL}/saml/logout/?redirect_to=${encodedURI}`
      const loginService = AuthorizationCredentialsServiceFactory.build()
      loginService.logout()
      this.#emit('logoutSuccess')
      window.location.replace(redirectUri)
    }
  
    const continueLogoutProcess = async (isLoggingout: boolean) => {
      if (isLoggingout) {
        this.#emit('logoutSuccess')
      }
    }

    return {
      logout,
      continueLogoutProcess,
    }
  }

}

export default UseSAMLLogout
